// Иконата „Извлечи данни от Търговски регистър" в края на полето „ЕИК" на
// получателя — същият вид като при издаване на фактура (pos токените), с
// общото поведение `useEikLookupFill`.

import { CloudDownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useEikLookupFill } from "../../../../../hooks/useEikLookupFill";
import { isValidEIK } from "../../../../../lib/companyValidators";
import type { EikLookupFields } from "../../../../../lib/eikLookupFields";
import { useOrderingMessage } from "../../useOrderingMessage";

interface Props {
  eik: string;
  onLookedUp: (fields: EikLookupFields) => void;
}

export function EikLookupSuffix({ eik, onLookedUp }: Props) {
  const { t } = useTranslation();
  const message = useOrderingMessage();
  const eikLookup = useEikLookupFill(message, onLookedUp);
  const lookupDisabled = !isValidEIK(eik.trim()) || eikLookup.isPending;

  return (
    <button
      type="button"
      onClick={() => eikLookup.lookup(eik)}
      disabled={lookupDisabled}
      title={t("invoiceCreate.lookupTitle")}
      aria-label={t("invoiceCreate.lookupTitle")}
      className={`inline-flex h-[26px] w-[26px] items-center justify-center rounded-md border-none ${
        lookupDisabled
          ? "cursor-not-allowed bg-transparent text-pos-muted"
          : "cursor-pointer bg-pos-selected-bg text-pos-accent-ink"
      }`}
    >
      {eikLookup.isPending ? (
        <LoadingOutlined className="text-[13px]" />
      ) : (
        <CloudDownloadOutlined className="text-[13px]" />
      )}
    </button>
  );
}
